// extracted by mini-css-extract-plugin
export default {"activeBtn":"header-component_activeBtn__ch1iQ"};